import elearningDetailsLocale from './en.json'

const en = {
  elearningDetails: elearningDetailsLocale,
}

export default en
